import { useEffect, useState } from "react";
import { JOBS } from "../mock";

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 5 * 60 * 1000;
let _count = null, _countAt = 0, _countP = null;

export function fetchJobsCount() {
  if (_count !== null && Date.now() - _countAt < POLL_MS) return Promise.resolve(_count);
  _countP ||= fetch(`${API}/api/jobs/count`).then((r) => r.json()).then((d) => { _count = d.open ?? 0; _countAt = Date.now(); return _count; }).catch(() => _count ?? 0).finally(() => { _countP = null; });
  return _countP;
}

export function useJobsCount() {
  const [n, setN] = useState(_count);
  useEffect(() => {
    let live = true;
    const tick = () => fetchJobsCount().then((v) => live && setN(v));
    tick();
    const t = setInterval(() => { _countAt = 0; tick(); }, POLL_MS);
    return () => { live = false; clearInterval(t); };
  }, []);
  return n;
}

export function useJobs() {
  const [items, setItems] = useState(null);
  useEffect(() => { fetch(`${API}/api/jobs`).then((r) => r.json()).then((d) => setItems(d.items?.length ? d.items : JOBS)).catch(() => setItems(JOBS)); }, []);
  return items || JOBS;
}
